import { render } from "./DBLinkedDataView.vue?vue&type=template&id=5ee25de5&scoped=true&ts=true"
import script from "./DBLinkedDataView.vue?vue&type=script&lang=ts"
export * from "./DBLinkedDataView.vue?vue&type=script&lang=ts"

import "./DBLinkedDataView.vue?vue&type=style&index=0&id=5ee25de5&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee25de5"]])

export default __exports__